const normalizeColor = (color) => typeof color === "string" ? color.toUpperCase() : "";
const resolveColorsPalette = (colors, currentColor, maxColors = 58) => {
  const colorSet = new Set(colors.map(normalizeColor).filter((color) => color !== ""));
  const normalizedCurrent = normalizeColor(currentColor);
  return normalizedCurrent === "" || colorSet.has(normalizedCurrent) ? Array.from(colorSet).slice(0, maxColors) : [...Array.from(colorSet).slice(0, maxColors - 1), normalizedCurrent];
};
export {
  resolveColorsPalette
};
//# sourceMappingURL=resolveColorsPalette.js.map
